import React from "react";
import "./SearchBar.css";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faMapMarkerAlt,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";

const SearchBar = ({
  searchTitle,
  setSearchTitle,
  selectCity,
  setSelectCity,
  cities,
  selectedExperience,
  setSelectedExperience,
  experienceOptions,
  handleSearch,
}) => {
  return (
    <div className="job-search-component">
      <div className="search-bar-pill">
        <div className="search-input-group">
          <FontAwesomeIcon icon={faSearch} className="input-icon" />

          <input
            type="text"
            placeholder="Search by Skills, Company or Job Title"
            value={searchTitle}
            onChange={(e) => setSearchTitle(e.target.value)}
            className="custom-base-input"
          />
        </div>

        <div className="search-input-group mid-border">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="input-icon" />

          <Select
            className="react-select-container"
            classNamePrefix="custom-select"
            placeholder="Location"
            value={selectCity}
            onChange={setSelectCity}
            options={cities}
            isClearable
          />
        </div>

        <div className="search-input-group">
          <FontAwesomeIcon icon={faBriefcase} className="input-icon" />

          <Select
            className="react-select-container"
            classNamePrefix="custom-select"
            placeholder="Experience"
            value={selectedExperience}
            onChange={setSelectedExperience}
            options={experienceOptions}
            isSearchable={false}
            isClearable
          />
        </div>

        <button className="pill-search-btn" onClick={handleSearch}>
          Search
        </button>
      </div>
    </div>
  );
};

export default SearchBar;